import { safeParseZodObject } from '@/src/shared/utils/parser';
import {
  TConsultListService,
  TOutletListService,
  TProductListService,
} from '../schemas';
import {
  SConsultListServiceRequest,
  SOutletListServiceRequest,
  SProductListServiceRequest,
  TConsultListServiceRequest,
  TOutletListServiceRequest,
  TProductListServiceRequest,
} from '../schemas/request';

export function mapOutletListServiceToOutletListServiceRequest(
  filter: TOutletListService
): TOutletListServiceRequest {
  return (
    safeParseZodObject<TOutletListServiceRequest>(SOutletListServiceRequest, {
      min_price: filter.min_price || undefined,
      max_price: filter.max_price || undefined,
      location: filter.lokasi?.length ? filter.lokasi : undefined,
      search: filter.search || undefined,
      longitude: filter.longitude || undefined,
      latitude: filter.latitude || undefined,
      order_by: filter.price_sort || undefined,
    }) ?? {}
  );
}

export function mapProductListServiceToProductListServiceRequest(
  filter: TProductListService
): TProductListServiceRequest {
  return (
    safeParseZodObject<TProductListServiceRequest>(SProductListServiceRequest, {
      min_price: filter.min_price || undefined,
      max_price: filter.max_price || undefined,
      location: filter.lokasi?.length ? filter.lokasi : [],
      search: filter.search || undefined,
      longitude: filter.longitude || undefined,
      latitude: filter.latitude || undefined,
      order_by: filter.order_by || undefined,
      offset: filter.offset || undefined,
      size: filter.size || undefined,
      is_not_ethical: filter.is_not_ethical || undefined,
    }) ?? {}
  );
}

export function mapConsultListServiceToConsultListServiceRequest(
  filter: TConsultListService
): TConsultListServiceRequest {
  return (
    safeParseZodObject<TConsultListServiceRequest>(SConsultListServiceRequest, {
      min_price: filter.min_price || undefined || null,
      max_price: filter.max_price || undefined || null,
      location: filter.lokasi?.length ? filter.lokasi : [],
      search: filter.search || null || undefined,
      longitude: filter.longitude || undefined,
      latitude: filter.latitude || undefined,
      order_by: filter.order_by || undefined,
      offset: filter.offset || undefined,
      size: filter.size || undefined,
      service_method: filter.service_method || undefined,
      payment_method: filter.payment_method || undefined,
      min_date: filter.min_date || undefined || null,
      max_date: filter.max_date || undefined || null,
    }) ?? {}
  );
}
